import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@mui/material";
import PrivateDash from "./dashboard";
import DoneIcon from "@mui/icons-material/Done";
import SettingsIcon from "@mui/icons-material/Settings";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { useLocalStorageContext } from "../../Context/LocalProvider";
import { setUser } from "../../utils/userSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function DashboardTopBar() {
  const user = JSON.parse(localStorage.getItem("user-info"));

  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDateTime(new Date());
    }, 1000); // Update every second

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Format time in HH:MM AM/PM format
  const formattedTime = dateTime.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // Get day of the week
  const dayOfWeek = dateTime.toLocaleString("en-US", { weekday: "long" });
  const userValue = useSelector((state) => state.user);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        fontWeight="bold"
        p={"10px"}
        sx={{ mb: "5px", color: "#fff" }}
      >
        <Typography sx={{ fontSize: "20px", color: "#000" }}>
          Welcome {userValue.name}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              color: "#000",
              paddingRight: "10px",
            }}
          >
            {formattedTime}
            <br />
            {dayOfWeek}
          </Typography>
          <Box
            sx={{
              backgroundColor: "#1d82f5",
              padding: "3px 10px",
              borderRadius: "3px",
              display: "flex",
              marginRight: "10px",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
              "&:hover": { backgroundColor: "orange" },
              height: "40px",
            }}
          >
            <ExitToAppIcon />
            &nbsp; Clock In
          </Box>
          <Box></Box>
          <React.Fragment>
            <Box
              onClick={handleClickOpen}
              sx={{ paddingRight: "10px", cursor: "pointer" }}
            >
              <SettingsOutlinedIcon sx={{ color: "#000" }} />
            </Box>
            <BootstrapDialog
              onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
              sx={{
                "& .MuiPaper-root": {
                  position: "absolute", // Make the dialog absolute
                  top: 0, // Position from the top
                  right: 0, // Position from the right
                  margin: 1, // Remove default margins
                  borderRadius: 0, // Optional: remove border-radius for a flush look
                },
              }}
            >
              <DialogTitle
                sx={{ m: 0, p: 2, bgcolor: "#fff", fontWeight: 600 }}
                id="customized-dialog-title"
              >
                Dashboard Widgets
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[900],
                })}
              >
                <CloseIcon />
              </IconButton>
              <DialogContent
                dividers
                sx={{
                  bgcolor: "#fff",
                  color: "#000",
                  borderTop: "1px solid gray",
                }}
              >
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Profile"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Shift Schedule"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Birthdays"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Notices"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Tasks"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Projects"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="My Tasks"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="My Calender"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Week Timelogs"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="On Leave Today"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Leads"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="On Work From Home Today"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Appreciations"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Work Anniversary"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Tickets"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Notice Period Duration"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Probation Date"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Contract Date"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
                <FormGroup
                  sx={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Internship Date"
                    sx={{ width: "200px" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#333",
                          "&.Mui-checked": {
                            color: "#1d82f5",
                          },
                        }}
                      />
                    }
                    label="Follow Ups"
                    sx={{ width: "200px" }}
                  />
                </FormGroup>
              </DialogContent>
              <DialogActions
                sx={{
                  bgcolor: "#fff",
                  color: "#000",
                  borderTop: "1px solid gray",
                }}
              >
                <Grid item xs={11} className="messageFooter">
                  <Box className="response" onClick={handleClose}>
                    <DoneIcon /> Save
                  </Box>
                </Grid>
              </DialogActions>
            </BootstrapDialog>
          </React.Fragment>
        </Box>
      </Box>

      {/* ICONS */}

      <PrivateDash></PrivateDash>
    </Box>
  );
}

export default DashboardTopBar;
